import * as React from 'react';

import { Form, Tab, Button } from 'semantic-ui-react';
import { StatisticsType, StatComparisionType } from 'src/services/graphql/Models';
import uuidv1 from 'uuid/v1';

// import validator from 'validator';
import { observer, inject } from 'mobx-react';
import TriggerableStat from 'src/stores/application/classes/TriggerableStat';
// import { removeTypename } from 'src/shared/typemap';
import { ListInput, BaseComponentClass } from '../../components/generic/ListInput';
import { deepEqual } from '../../shared/utility';

export const statTypeOptions = [
    {
        key: StatisticsType.value,
        text: 'Value',
        value: StatisticsType.value,
    },
    {
        key: StatisticsType.min,
        text: 'Minimum',
        value: StatisticsType.min,
    },
    {
        key: StatisticsType.max,
        text: 'Maximum',
        value: StatisticsType.max,
    },
    {
        key: StatisticsType.total,
        text: 'Total',
        value: StatisticsType.total,
    },
    {
        key: StatisticsType.average,
        text: 'Average',
        value: StatisticsType.average,
    }
];

export const statComparisionTypeOption = [
    {
        key: StatComparisionType.notCompared,
        text: 'No Comparision',
        value: StatComparisionType.notCompared,
    },
    {
        key: StatComparisionType.percentage,
        text: 'Percentage of ',
        value: StatComparisionType.percentage,
    },
    {
        key: StatComparisionType.addition,
        text: 'Added with ',
        value: StatComparisionType.addition,
    },
    {
        key: StatComparisionType.subtraction,
        text: 'Subtracted from ',
        value: StatComparisionType.subtraction,
    },
    {
        key: StatComparisionType.division,
        text: 'Divided by ',
        value: StatComparisionType.division,
    },
    {
        key: StatComparisionType.multiplication,
        text: 'Multiplied by',
        value: StatComparisionType.multiplication,
    }
];

export class TriggerableStatInput extends BaseComponentClass {
    reset: boolean;
    get currentStatValue() {
        return new TriggerableStat({
            ...this.state,
            clientId: this.props.value.clientId,
            typedId: this.props.value.typedId
        });
    }

    getInitialValue(stateVal: any) {
        const props = this.props;
        
        if (
            this.props.isNew ||
            !Array.isArray(props.initialValues)
        ) {
            return undefined;
        } else {
        
            return props.initialValues.find(
                _initialValue => _initialValue.typedId === stateVal.typedId
            );

        }
    }

    constructor(props: any) {
        super(props);
        
        if (props.isNew) {
            this.state = {
                ...props.value,
                associatedChart: props.chartId,
                noSaveButtons: false
            };
        } else {
            this.state = {
                ...props.value,
                noSaveButtons: true
            };
        }

        if (props.isFirst) {
            props.registerSaveCallback(this.saveCallback.bind(this));
        }
    }

    hasNoSaveButton(newState?: any) {
        const state = newState || this.state;
        const { noSaveButtons, ...stateVal} = state;
        const initialValue = this.getInitialValue(stateVal);

        if (initialValue) {
            const _stateVal = Object.assign({}, stateVal, {
                statIndex: initialValue.statIndex
            });
            return deepEqual(initialValue, _stateVal);
        } else {
            return true;
        }
        
    }

    componentDidUpdate() {
        const noSaveButtons = this.hasNoSaveButton();
        
        if ( noSaveButtons  !== this.state.noSaveButtons) {
                this.setState({noSaveButtons});
        }
    }

    saveCallback() {
        const me = this;
        if (me.props.isFirst) {
            me.handleSaveCall();
            
        } 
    }

    render() {
        const {
            name,
            statType,
            comparisionType,
            comparedToStatType,
            comparisionValue,
            noSaveButtons
        } = this.state;
          
        const statName = this.props.couldOnlyHaveOneValue ?
          'input value'
          : ( 
              statTypeOptions.find(o => o.key === statType) 
              || { text: 'Input stat'} 
          ).text;

        const changeHandler = this.handleChange.bind(this);
        const reset = this.reset;
        this.reset = false;
        return (
            <Tab.Pane key={`${this.state.typedId}${reset === true ? ':reset' : ''}`}>
                
                {(this.props.couldOnlyHaveOneValue) ?
                    null
                    : [ 
                        <Form.Field key="0">
                            <Form.Input 
                                placeholder="Name for the Stat" 
                                label="Statistic Name"
                                name="name" 
                                defaultValue={name} 
                                onChange={changeHandler} 
                            />
                        </Form.Field>,
                        <Form.Field key="1">  
                            <Form.Select
                                label="Statistic Type" 
                                onChange={changeHandler}
                                options={statTypeOptions}
                                placeholder="What information is to be displayed?" 
                                name="statType" 
                                defaultValue={statType} 
                            />
                        </Form.Field>
                    ]
                }
                <Form.Field>
                    <Form.Select
                        label="Comparision" 
                        onChange={changeHandler}
                        options={statComparisionTypeOption}
                        placeholder={`Comparing the Stat With (optional)`}
                        name="comparisionType" 
                        defaultValue={comparisionType} 
                    />
                </Form.Field>

                {(comparisionType !== StatComparisionType.notCompared) ?
                    (       
                        <Form.Field>  
                            <Form.Select
                                label="Statistic Type" 
                                onChange={changeHandler}
                                options={statTypeOptions}
                                placeholder={`What ${statName} is Compared with?`} 
                                name="comparedToStatType" 
                                defaultValue={comparedToStatType} 
                            />
                        </Form.Field>
                    )
                    : null
                }

                {(comparedToStatType === StatisticsType.value) ?
                    (       
                        <Form.Field>  
                            <Form.Input
                                label="Compared with Value:" 
                                onChange={changeHandler}
                                placeholder="value stat is compared with" 
                                name="comparisionValue" 
                                defaultValue={comparisionValue} 
                            />
                        </Form.Field>
                    ) : null
                }
                
                { noSaveButtons || this.props.isNew ? null : (
                  <Button.Group>
                    <Button 
                        type="button"
                        onClick={this.handleCancelCall.bind(this)}
                    >   Cancel
                    </Button>
                    <Button.Or />
                    <Button 
                        type="button"
                        onClick={this.handleSaveCall.bind(this)}
                        positive
                    >   Save
                    </Button>
                  </Button.Group>   
                )}
            </Tab.Pane>
        );
    }

    handleSaveCall() {
        const input = {
            ...this.currentStatValue,
            associatedChart: this.props.chartId,
            clientId: this.props.clientId
        };
        const { noSaveButtons, ...stateVal} = this.state;
        const initialValue = this.getInitialValue(stateVal);
        
        if (initialValue) {
            input.triggers = initialValue.triggers;
        }

        if (this.props.isNew) {
            this.props.dataStore.create(input);
        } else {
            this.props.dataStore.update(input);
        }
    }

    handleCancelCall() {
        if (window.confirm('Are you sure you want to cancel?')) {
            const initialValue = this.getInitialValue(this.state);
            this.reset = true;
            this.setState(
                initialValue
            );
        }
    }

    handleChange(e: any, {name, value}: any) {
        const delta = {[name]: value};
        const newState = Object.assign({}, this.state, delta);
        let { noSaveButtons, ...actualValue } = newState;
        
        noSaveButtons = this.hasNoSaveButton(newState);
        
        this.setState({[name]: value, noSaveButtons}, () => {
            const newData = Object.assign({}, actualValue, {[name]: value});
            this.props.onChange(newData);
        });
    }
}

@inject('triggerableStats', 'authStore')
@observer
export default class TriggerableTabs extends React.Component<any, any> {
    get statList() {
        const { 
            triggerableStats,
            chartId
        } = this.props;
        const parsedItems = triggerableStats.getParsedItems;
        return parsedItems.filter(o => o.associatedChart === chartId);
    }

    constructor (props: any) {
        super(props);        
        this.state = {
            values: this.statList,
            initialValues: this.statList
        };
    }

    validate(t: TriggerableStat) {
        let result: any[] = [];
        const statistics = [
            StatisticsType.average, 
            StatisticsType.max, 
            StatisticsType.min, 
            StatisticsType.total, 
            StatisticsType.value
        ];
        const comparisionType = [
            StatComparisionType.addition,
            StatComparisionType.division,
            StatComparisionType.multiplication,
            StatComparisionType.percentage,
            StatComparisionType.subtraction
        ];
        if (
            !t.name ||
            t.name.length <= 2
        ) {
            result.push('Invalid statistic name.');
        }

        if (
            statistics.every(o => t.statType !== o )
        ) {
            result.push('Invalid statics type.');
        }
        
        if (
            StatComparisionType.notCompared !== t.comparisionType &&
            comparisionType.every(o => t.comparisionType !== o )
        ) {
            result.push('Invalid comparsion, please select not Compared for default.');
        }

        if (
            StatComparisionType.notCompared !== t.comparisionType &&
            statistics.every(o => o === t.comparedToStatType)
        ) {
            result.push('Comparision to data required .');
        }

        if (result.length > 0) {
            return result;
        }
        return true;
    }

    change (values: any[]) {
        values.forEach((val, ind) => {
            if (val.statIndex !== ind) {
                val.statIndex = ind;
                this.props.triggerableStats.update(new TriggerableStat(val));
                
            }
        });
        
        this.setState({values});
        
    }

    handleAdd (e: any, value: any) {
        this.props.triggerableStats.create(new TriggerableStat(value));
    }

    handleDelete(e: any, value: any) {
        this.props.triggerableStats.delete(new TriggerableStat(value));
    }
    render() {
        const change = this.change.bind(this);
        const add = this.handleAdd.bind(this);
        const handleDelete = this.handleDelete.bind(this);
        
        const validate = this.validate.bind(this);
        const { 
            triggerableStats,
            authStore,
            chartId,
            name,
            ...props
        } = this.props;

        const initialValues = this.state.initialValues.sort((a, b) => a.statIndex - b.statIndex);
        
        return (
            <div>
                <ListInput
                    initialValues={initialValues}
                    defaultValue={(args: any) => {
                        return {         
                            name: 'Current Value',
                            clientId: authStore.clientId,
                            associatedChart: chartId,
                            statType: StatisticsType.value,
                            comparisionType: StatComparisionType.notCompared,
                            triggers: [],
                            typedId: `ts:${uuidv1()}`
                        };
                    }}
                    name="Test"
                    onValuesChange={change}
                    validate={validate}
                    handleAdd={add}
                    handleDelete={handleDelete}
                    Item={(p) => <TriggerableStatInput   {...p} {...props} dataStore={triggerableStats}/>}
                    StagingItem={(p) => <TriggerableStatInput  {...p} {...props} dataStore={triggerableStats}/>}
                    addButtonText="Add Statistic"
                    customEditEvent
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/container/TriggerableStats/TriggerableStatEdit.tsx